import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import WorkLayout from '../../../layouts/Work'
import SlideDeck from '../../../assets/decks/tropicana_case-study_master.pdf'
import displayImg from '../../../assets/images/tropicana_display.png'
import demoGif from '../../../assets/images/tropicana_demo.gif'

const Work = () => {
  return (
    <WorkLayout
        pageTitle="Delivery app"
        date="2021-2022"
        role="Designer & Consultant"
        company="Tropicana"
        slidesLink={SlideDeck}
        figmaLink={"https://www.figma.com/proto/WREUqo1jXYqqlYw6e3tzvX/Tropicana-Tracker?page-id=1442%3A4421&node-id=1442-4422&viewport=265%2C512%2C0.19&t=ZhNdbzl7hGxPnnY9-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=1442%3A4422&show-proto-sidebar=1"}
        video
        >
      <section className='work-hero'>
        <img src={displayImg} alt="tropicana beauty shot"/>
      </section>
      
      <section className='work-highlight'>
        <h2>A web app that bridges the gap between business and driver, allowing both to become more effecient and profitable.</h2>
      </section>

      <section className='work-summary'>
        <header className="work-header">
          <h2>Summary</h2>
        </header>
        <p>
          Having acquired Tropicana from Pepsi in 2021 in a $3B deal, the company aimed to streamline processes to increase profits. I was approached to design a kiosk app intended to create multiple lanes for trucks and free up staff to perform their core duties.
        </p>
        <p>In discovery, I found and proposed an alternative solution that was quicker to market while solving several high-risk business problems.</p>
        <section className='work-summary__section'>
          <h3>My role</h3>
          <p>I worked as the lead design consultant alongside the Sr. Distribution Center Manager, WMS Manager, and a contracted development firm.</p>
        </section>
      </section>

    

      <section className="work-feature">
        <Row>
          <Col>
            <img className="work-gif" width="120px" src={demoGif} alt="tropicana app demo"/>
          </Col>
          <Col>
            <ul>
              <li>
                <h3 className='work-feature__title'>Real time updates</h3>
                <p>Be notified the second your order is ready for pickup. Feel free to take other deliveries in the meantime.</p>
              </li>
              <li>
                <h3 className='work-feature__title'>Appointment details</h3>
                <p>Easily find your pickup appointment date and time.</p>
              </li>
              <li>
                <h3 className='work-feature__title'>Link to maps</h3>
                <p>No longer do you need to check-in to find your lot #.</p>
              </li>
              <li>
                <h3 className='work-feature__title'>Multiple languages</h3>
                <p>English and spanish translations available.</p>
              </li>
            </ul>
          </Col>
        </Row>
      </section>

      <section className="work-feature">
        <ul>
          <li>
            <header className="work-header">
              <h4>Business Problem #1</h4>
              <h2>Detention fees</h2>
            </header>
            <p>
              Delays beyond the scheduled time results in a charge of $1 per minute to Tropicana.
            </p>
          </li>

          <li>
            <header className="work-header">
              <h4>Business Problem #2</h4>
              <h2>Dwell fees</h2>
            </header>
            <p>
              Carriers can drop off an empty trailer to be filled and picked up later. After 3 days going unfilled, carriers charge a dwell fee to Tropicana.
            </p>
          </li>

          <li>
            <header className="work-header">
              <h4>Business Problem #3</h4>
              <h2>Staff stress & traffic</h2>
            </header>
            <p>
              Check-in staff often face confrontations with drivers. Residents have been complaining for years about the traffic delays caused by trucks on major roadways in Bradenton.
            </p>
          </li>

          <li>
            <header className="work-header">
              <h4>Business Problem #４</h4>
              <h2>Drivers frustration</h2>
            </header>
            <p>
              Often waiting 5+ hours and missing potential delivery opportunities, Drivers must return to Tropicana to check load status.
            </p>
          </li>
        </ul>
      </section>

      <section>
        <h2>Simple solution with big results</h2>
        <blockquote>
          <p><em>"Our drivers are loving it. Tropicana is planning to install at all of our plants"</em><br /> – Tropicana WMS Manager</p>
        </blockquote>
        <ul>
          <li>225k/yr saved in detention & dwell fees</li>
          <li>90%+ adoption rates (100% of large carriers)</li>
          <li>Cleared check-in queues</li>
        </ul>
      </section>

      <section className='work-highlight'>
        <h2>Due to the success of Bradenton’s location, Tropicana is launching nationwide for plants in: Ft. Pierce (FL), Jersey City (NJ), Cincinnati (OH), and Walnut (CA).</h2>
      </section>
    </WorkLayout>
  )
}

export default Work;
